import {
  IMAGE,
  POLL_CHART,
  POLL_RESULT,
  QUIZ_RESULT,
  TEXT,
} from '../constants';

export function rewirePollOption(widget, styleEntities) {
  const style = styleEntities.styles[widget.styleId];

  if (style.textWidget && 'text' in widget) {
    const id = `${widget.id}-text`;
    const textWidget = styleEntities.widgets[style.textWidget];
    const textChild = {
      id,
      type: TEXT,
      content: widget.text,
      className: style.textWidget,
      styledStates: textWidget?.styledStates,
    };
    widget.addChild(textChild);
  }

  if (style.imageWidget && 'imageUrl' in widget) {
    const id = `${widget.id}-image`;

    const url = widget.imageUrl.replace(/^https?:/, '');
    const imageChild = {
      id,
      type: IMAGE,
      url,
      className: style.imageWidget,
      overlays: [],
    };
    widget.addChild(imageChild);
  }

  const pollResultState = widget.slide?.pollState === 'result';
  const quizResultState = widget.slide?.quizState === 'result';

  if (pollResultState || quizResultState) {
    const resultWidgetId = `${widget.id}-result`;
    const resultWidget = {
      type: pollResultState ? POLL_RESULT : QUIZ_RESULT,
      id: resultWidgetId,
      children: [],
      optionId: widget.optionId,
      addChild: widget.addChild,
    };

    widget.addChild(resultWidget);

    if (style.resultProgressWidget) {
      resultWidget.addChild({
        type: POLL_CHART,
        id: `${widget.id}-result-chart`,
        className: style.resultProgressWidget,
      });
    }
    if (style.percentTextWidget) {
      resultWidget.addChild({
        type: TEXT,
        id: `${widget.id}-result-text`,
        className: style.percentTextWidget,
      });
    }
  }
}
